"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentStatusToString = transformPaymentStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPaymentStatusToString(orderStatus) {
    switch (orderStatus) {
        case legacy_enums_1.PaymentStatus.Fulfilled:
            return "fulfilled";
        case legacy_enums_1.PaymentStatus.Failed:
            return "failed";
        case legacy_enums_1.PaymentStatus.ChargedBack:
            return "charged back";
        case legacy_enums_1.PaymentStatus.Pending:
            return "pending";
        case legacy_enums_1.PaymentStatus.PreAuthorized:
            return "pre-authorized";
        case legacy_enums_1.PaymentStatus.Uncaptured:
            return "uncaptured";
        case legacy_enums_1.PaymentStatus.Cancelled:
            return "cancelled";
        default:
            return "unknown status";
    }
}
//# sourceMappingURL=transformPaymentStatusToString.js.map